// get different time formats
const today = new Date();
const isoDate = today.toISOString();
const date = today.getDate().toString().padStart(2, "0");
const hours = today.getHours().toString().padStart(2, "0");
const minutes = today.getMinutes().toString().padStart(2, "0");
const month = today.getMonth().toString().padStart(2, "0");
const nanos = today.getMilliseconds();
const seconds = today.getSeconds().toString().padStart(2, "0");
const time = today.getTime();
const year = today.getFullYear();

const dateFormatted = `${year}-${month}-${date} ${hours}:${minutes}:${seconds}`;

const dateSplit = {
  date,
  hours,
  minutes,
  month,
  nanos,
  seconds,
  time: 0,
  year,
};

function returnAccumfs() {
  return {
    cleared: 0,
    colcash: 0,
    colcc: 0,
    colchq: 0,
    coleazzy: 0,
    colmp: 0,
    colot: 0,
    reccc: 0,
    date: isoDate,
    format: "",
    id: 0,
    levyamt: 0,
    petty: 0,
    picks: 0,
    recot: 0,
    sales: 0,
    session: 0,
    sfloat: 0,
    till: "TILL01",
    till_end: null,
    till_start: null,
    uzer: "GNJ",
    vatamt: 0,
  };
}

function returnTransaction() {
  return {
    account: 0,
    cust_order: "",
    date: isoDate,
    doc_Ref: "test",
    due_date: isoDate,
    id: 0,
    init1: "GNJ",
    init1_dte: dateFormatted,
    init2: "",
    init2_dte: null,
    levy_1: 0,
    levy_2: 0,
    levy_3: 0,
    name: "Cash Sales A/c",
    paid: 0,
    period: 0,
    remark: "Front-end test",
    salesman: "",
    session: 1,
    till: "TILL01",
    trn_no: 0,
    type: "CSL",
    updstock: 0,
  };
}

export {
  returnAccumfs,
  today,
  dateSplit,
  isoDate,
  returnTransaction,
  dateFormatted,
};
